module.exports = __webpack_public_path__ + "static/media/W.c5741397.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/W.svg
// module id = 412
// module chunks = 0